import { CheckList, RadioList, TextInput } from "@milestone/component-library";
import React, { useEffect, useState } from "react";
import { Formik, FormikHelpers } from "formik";
import {
  BlueButton,
  ColumnContainer,
  OutlineButton,
  SaveButtonContainer,
  StyledForm,
} from "../../Admin.styles";
import {
  StatusOptions,
  OfficeFormType,
  OfficeFormSchema,
  OfficeFormHeader,
} from "./officeFormSchema";
import {
  CheckListContainer,
  Header,
  Section,
  TopSaveWrapper,
} from "./officeForm.styles";
import { useHistory } from "react-router-dom";
import { Api } from "../../../../services/api";
import { Company } from "../../../../services/api/types/Companies";
import { handleAxiosError } from "../../../../services/utils/handleAxiosError";
import { CompanyStatus } from "../../../../enums";

interface OfficeFormProps {
  header: string;
  submitValues: (
    values: OfficeFormType,
    actions: FormikHelpers<OfficeFormType>
  ) => void;
  value?: OfficeFormType;
  canSave?: boolean;
}

export const OfficeForm: React.FC<OfficeFormProps> = ({
  header,
  submitValues,
  value,
  canSave = true,
}) => {
  const [companiesMap, setCompaniesMap] = useState<Map<string, Company>>(
    new Map()
  );
  const defaultOfficeInfo: OfficeFormType = {
    status: StatusOptions[0],
    name: "",
    address: "",
    companies: [],
  };

  const getCompanies = () => {
    Api.companies
      .get()
      .then(res => {
        const companies = new Map<string, Company>();
        res.data.companies.map(company => {
          //only show active companies
          if (company.status === CompanyStatus.Active)
            companies.set(company.name, company);
        });
        setCompaniesMap(companies);
      })
      .catch(error => {
        console.error(error);
        handleAxiosError(error);
      });
  };

  useEffect(() => {
    getCompanies();
  }, []);

  if (value) {
    if (value.status) defaultOfficeInfo.status = value.status;
    if (value.name) defaultOfficeInfo.name = value.name;
    if (value.address) defaultOfficeInfo.address = value.address;
    if (value.companies) defaultOfficeInfo.companies = value.companies;
  }

  const history = useHistory();

  const handleCancel = () => {
    const currentLocation = history.location;
    currentLocation.pathname = "/admin/offices";
    history.push(currentLocation);
  };

  const SaveButtons = (
    <SaveButtonContainer>
      <BlueButton type={canSave ? "submit" : "button"}>Save</BlueButton>
      <OutlineButton type="button" onClick={handleCancel}>
        Cancel
      </OutlineButton>
    </SaveButtonContainer>
  );

  return (
    <ColumnContainer>
      <Formik
        initialValues={defaultOfficeInfo}
        validationSchema={OfficeFormSchema}
        onSubmit={submitValues}
      >
        {() => (
          <StyledForm>
            <TopSaveWrapper>{SaveButtons}</TopSaveWrapper>
            <Header>{header}</Header>
            <Section>
              {header !== OfficeFormHeader.add && (
                <div>
                  <RadioList
                    label="Status"
                    name="status"
                    options={StatusOptions}
                  />
                </div>
              )}

              <TextInput
                name="name"
                label="Office Name"
                placeholder="Office Name"
              />
              <TextInput name="address" label="Address" placeholder="Address" />
            </Section>
            <CheckListContainer>
              <CheckList
                label="Company"
                name="companies"
                options={[...companiesMap.keys()]}
              />
            </CheckListContainer>
            {/*errors && <div>{JSON.stringify(errors)}</div>*/}
          </StyledForm>
        )}
      </Formik>
    </ColumnContainer>
  );
};
